import axios from 'axios'
import { config } from '../../Constants'

export const publicApi = {
  getQueueMap,
  getReportMap
}

function getQueueMap(user) {
  return instance.get('/public/qmap')
}

function getReportMap(user) {
  return instance.get('/public/rmap')
}

// -- Axios

const instance = axios.create({
  baseURL: config.url.API_BASE_URL
})

// -- Helper functions

function basicAuth(user) {
  return `Basic ${user.authdata}`
}
